<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (isReady) {
  @if (orders?.length) {
    <table class="table-depot table-orders mb-0" @onlyEnter aria-describedby="open">
      <tbody>
        <tr>
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="assetName"
              label="mydepot.depotoverview.open-orders.labels.assetName"
              direction="after"
              (click)="sortBy('assetName')"
            /><br />
            <web-components-sorter-label
              [sorter]="sorter"
              attr="isin"
              label="mydepot.depotoverview.open-orders.labels.isin"
              direction="after"
              (click)="sortBy('isin')"
            />
          </th>
          <th>
            {{ 'mydepot.depotoverview.open-orders.labels.openQuantity' | transloco }}<br />
            {{ 'mydepot.depotoverview.open-orders.labels.status' | transloco }}
          </th>
          <th>
            {{ 'mydepot.depotoverview.open-orders.labels.execType' | transloco }}<br />
            <span class="text-nowrap">{{ 'mydepot.depotoverview.open-orders.labels.stopLimit' | transloco }}</span>
          </th>
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="openDate"
              label="mydepot.depotoverview.open-orders.labels.openDate"
              direction="before"
              (click)="sortBy('openDate')"
            />
            <br />
            <web-components-sorter-label
              [sorter]="sorter"
              attr="validToDate"
              label="mydepot.depotoverview.open-orders.labels.validToDate"
              direction="before"
              (click)="sortBy('validToDate')"
            />
          </th>
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="direction"
              label="mydepot.depotoverview.open-orders.labels.direction"
              direction="before"
              (click)="sortBy('direction')"
            /><br />
            {{ 'mydepot.depotoverview.open-orders.labels.value' | transloco }}
          </th>
          <th>
            {{ 'mydepot.depotoverview.open-orders.labels.surcharge' | transloco }}<br />
            {{ 'mydepot.depotoverview.open-orders.labels.provision' | transloco }}
          </th>
          <th>
            {{ 'mydepot.depotoverview.open-orders.labels.orderQuoteTime' | transloco }}<br />
            {{ 'mydepot.depotoverview.open-orders.labels.quote' | transloco }}
          </th>
          @if (actionsEnabled) {
            <th></th>
          }
        </tr>
        @for (order of orders; track order.id) {
          <tr
            app-open-order-item
            [order]="order"
            [isin2quote]="isin2quote"
            [actionsEnabled]="actionsEnabled"
            (cancelOrder)="cancelOrder($event)"
            (editOrder)="toggleEditOrder($event)"
          ></tr>
          @if (askForCancellation(order)) {
            <tr zero-cancel-open-order-item [order]="order" (canceled)="cancelationResult(order, $event)"></tr>
          }
          @if (editOrder?.orderId === order.orderId) {
            <tr>
              <td colspan="8">
                <web-components-trading-session (authorizationState)="isSessionAuthorized = $event" />
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  } @else {
    <p class="mt-3 mb-0">
      {{ 'mydepot.depotoverview.open-orders.empty' | transloco }}
    </p>
  }
}

<ng-template #empty>
  <p class="mt-3 mb-0">
    {{ 'mydepot.depotoverview.open-orders.empty' | transloco }}
  </p>
</ng-template>

@if (isSessionAuthorized && editOrder) {
  <order-edit-order [order]="editOrder" (dismiss)="editOrder = null" (cancelFinished)="redirectToOrdermask(editOrder)" />
}
